export const getData = (obj, path)=>{
    if (!obj) return undefined;
    if (!path) return obj;
    // constants
    const keys = path.replace(/\[(\w+)\]/g, '.$1').split('.');
    return keys.reduce((acc, key)=>acc === null || acc === void 0 ? void 0 : acc[key], obj);
};
export const setToObject = (obj, path, value)=>{
    // variables
    let keys = path.split('.');
    let current = {
        ...obj || {}
    };
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        // if we're at the last key, set the value
        if (i === keys.length - 1) current[key] = value;
        else {
            // convert numeric strings to numbers for array indexing
            const nextKey = isNaN(keys[i + 1]) ? keys[i + 1] : Number(keys[i + 1]);
            // create object/array if it doesn't exist
            if (!(key in current) || current[key] === null) {
                current[key] = typeof nextKey === 'number' ? [] : {};
            }
            current = current[key];
        }
    }
    return current;
};
